interface HTMLElementWithObserver extends HTMLElement {
  _observer?: IntersectionObserver
}

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.directive("observe-visibility", {
    mounted(
      el: HTMLElementWithObserver,
      binding: DirectiveBinding<(entry: IntersectionObserverEntry) => void>
    ) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry && entry.isIntersecting) {
            binding.value(entry)
          }
        },
        { rootMargin: "0px", threshold: 0.5, root: null }
      )
      el._observer = observer
      observer.observe(el)
    },
    unmounted(el: HTMLElementWithObserver) {
      if (el._observer) {
        el._observer.disconnect()
      }
    }
  })
})
